<!-- =========================================================================================
  File Name: pay.vue
  Description: Money Pay
========================================================================================== -->

<template>
  <div id="money-send">

    <vx-card title="第三方支付">

      <div slot="actions">
        <vs-button size="small" color="success" type="filled" @click="add">添加新第三方支付</vs-button>
      </div>

      <vs-table stripe :data="list" noDataText="暂无数据">
        <template slot="thead">
          <vs-th width="80">ID</vs-th>
          <vs-th width="150">名称</vs-th>
          <vs-th width="200">商户号</vs-th>
          <vs-th width="450">密匙</vs-th>
          <vs-th width="150">额度限制 (元)</vs-th>
          <vs-th width="100">状态</vs-th>
          <vs-th width="200">排序(数值越小越靠前)</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.name">{{item.name}}</vs-td>
            <vs-td :data="item.appid">{{item.appid}}</vs-td>
            <vs-td :data="item.key">{{item.key}}</vs-td>
            <vs-td :data="item.min">{{item.min}} - {{item.max}}</vs-td>
            <vs-td :data="item.enable">{{item.enable == 1 ? '开启' : '关闭'}}</vs-td>
            <vs-td :data="item.order">{{item.order}}</vs-td>
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-3">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" :title="modifyIndex !== -1 ? '更改第三方信息' : '添加第三方信息'" @confirm="submit">
      <div class="p-4">
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.name" label="平台名称" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.appid" label="商户号" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.key" label="密匙" />
        </div>
        <div class="mb-4">
          <vs-select class="w-full" v-model="modifyItem.enable" label="状态">
            <vs-select-item value="1" text="开启" />
            <vs-select-item value="0" text="关闭" />
          </vs-select>
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.order" label="排序 (数值越小越靠前)" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.intro" label="介绍" />
        </div>

        <vs-divider></vs-divider>

        <div class="mb-4">
          <vs-table stripe :data="modifyItem.channel" noDataText="暂无渠道">
            <template slot="header">
              <div class="w-full mb-2 flex items-center justify-between">
                <h5>充值渠道</h5>
                <vs-button color="success" size="small" @click="addChannel">添加</vs-button>
              </div>
            </template>
            <template slot="thead">
              <vs-th width="80">类型</vs-th>
              <vs-th width="80">名称</vs-th>
              <vs-th width="80">编号</vs-th>
              <vs-th width="80">最低</vs-th>
              <vs-th width="80">最高</vs-th>
              <vs-th width="60">
                <div class="text-center w-full">操作</div>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(item, index) in modifyItem.channel" >
                <vs-td :data="item.icon">
                  <vs-select class="w-full" v-model="item.icon">
                    <vs-select-item v-for="(item2, index2) in channelTypeList" :key="index2" :value="item2.icon" :text="item2.name" />
                  </vs-select>
                </vs-td>
                <vs-td :data="item.name">
                  <vs-input class="w-full" v-model="item.name" />
                </vs-td>
                <vs-td :data="item.number">
                  <vs-input class="w-full" v-model="item.number" />
                </vs-td>
                <vs-td :data="item.min">
                  <vs-input class="w-full" v-model="item.min" />
                </vs-td>
                <vs-td :data="item.max">
                  <vs-input class="w-full" v-model="item.max" />
                </vs-td>
                <vs-td>
                  <vs-button class="w-full pl-0 pr-0" color="danger" type="flat" size="small" @click="delChannel" :data-index="index">删除</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

export default {
  data() {
    return {
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      channelTypeList: [
        { icon: 'wx', name: '微信' },
        { icon: 'alipay', name: '支付宝' },
        { icon: 'bank', name: '银行' }
      ]
    }
  },
  components: {
    modifySiderBar
  },
  methods: {
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.$refs.modifySiderBar.open()
    },
    add () {
      this.modifyIndex = -1
      this.modifyItem = { id: -1, icon: 'icbc', enable: 1, order: 0, intro: '', channel: [] }
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.channel = JSON.stringify(postdata.channel)
      postdata.authKey = localStorage.getItem('authKey')
      this.$utils.post('money-bankPayDo', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        this.load()
        this.$refs.modifySiderBar.close()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该第三方信息吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('money-bankPayDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    addChannel () {
      this.modifyItem.channel.push({})
    },
    delChannel (e) {
      const index = parseInt(e.currentTarget.dataset.index)
      this.modifyItem.channel.splice(index, 1)
    },
    load() {
      this.$utils.post('money-bankPayList', { authKey: localStorage.getItem('authKey') }).then(res => {
        for (let i = 0; i < res.length; i++) {
          try{
            res[i].channel = JSON.parse(res[i].channel)
          } catch (e) {
            res[i].channel = []
          }
        }
        this.list = res
      })
    }
  },
  mounted () {
    this.load()
  }
}
</script>
